<div class="empty-state-content" [ngStyle]="{'maxWidth': maxWidth}">
    <img *ngIf="image" class="empty-state-image" [src]="image" [ngStyle]="{'maxWidth': imgMaxWidth}" />
    <span *ngIf="icon" class="empty-state-icon" [ngClass]="icon"></span>
    <h4 *ngIf="title" class="title" [attr.id]="idTimestamp ? 'h4_'.concat(idTimestamp) : ''" [innerHTML]="title"></h4>
    <p *ngIf="details" class="lead" [attr.id]="idTimestamp ? 'p_'.concat(idTimestamp) : ''" [innerHTML]="details"></p>
    <ng-content></ng-content>
</div>


